// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7441) return "static/chunks/7441-e0bd8539d3d933d2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5853":"ea3ac9c281559f2d","6993":"b32436cc3a39809c"}[chunkId] + ".js";
};